import React from "react";
import {
  landlordDisplayName,
  propertyManagerDisplayName,
} from "./unitDetailHelpers";

export default function UnitAssignModal({
  isOpen,
  assignSaving,
  assignListsLoading,
  assignForm,
  setAssignForm,
  assignLists,
  assignErr,
  onClose,
  onSave,
}) {
  if (!isOpen) return null;
  return (
          <div
            className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4"
            onClick={() => !assignSaving && onClose()}
            role="presentation"
          >
            <div
              className="w-full max-w-lg rounded-xl border border-black/10 bg-white dark:border-white/[0.07] dark:bg-[#141824] p-6 shadow-lg max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="unit-assign-title"
            >
              <h2 id="unit-assign-title" className="text-lg font-semibold text-[#eef2ff] mb-1">
                Zuordnungen
              </h2>
              <p className="text-sm text-[#6b7a9a] mb-4">
                Eigentümer, Verwaltung, Bewirtschafter und Liegenschaft für diese Unit.
              </p>
              {assignListsLoading ? (
                <p className="text-sm text-[#6b7a9a] py-4">Lade Auswahl …</p>
              ) : (
                <div className="space-y-4">
                  <div>
                    <label htmlFor="unit-assign-property" className="block text-xs font-medium text-[#6b7a9a] mb-1">
                      Liegenschaft
                    </label>
                    <select
                      id="unit-assign-property"
                      value={assignForm.property_id}
                      onChange={(e) =>
                        setAssignForm((f) => ({ ...f, property_id: e.target.value }))
                      }
                      disabled={assignSaving}
                      className="w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] bg-slate-100 dark:bg-[#111520]"
                    >
                      <option value="">—</option>
                      {assignLists.properties.map((p) => (
                        <option key={p.id} value={p.id}>
                          {String(p.title || "").trim() || p.id}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="unit-assign-landlord" className="block text-xs font-medium text-[#6b7a9a] mb-1">
                      Verwaltung
                    </label>
                    <select
                      id="unit-assign-landlord"
                      value={assignForm.landlord_id}
                      onChange={(e) =>
                        setAssignForm((f) => ({ ...f, landlord_id: e.target.value }))
                      }
                      disabled={assignSaving}
                      className="w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] bg-slate-100 dark:bg-[#111520]"
                    >
                      <option value="">—</option>
                      {assignLists.landlords.map((ll) => (
                        <option key={ll.id} value={ll.id}>
                          {landlordDisplayName(ll)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="unit-assign-pm" className="block text-xs font-medium text-[#6b7a9a] mb-1">
                      Bewirtschafter
                    </label>
                    <select
                      id="unit-assign-pm"
                      value={assignForm.property_manager_id}
                      onChange={(e) =>
                        setAssignForm((f) => ({ ...f, property_manager_id: e.target.value }))
                      }
                      disabled={assignSaving}
                      className="w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] bg-slate-100 dark:bg-[#111520]"
                    >
                      <option value="">—</option>
                      {assignLists.pms.map((pm) => (
                        <option key={pm.id} value={pm.id}>
                          {propertyManagerDisplayName(pm)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="unit-assign-owner" className="block text-xs font-medium text-[#6b7a9a] mb-1">
                      Eigentümer
                    </label>
                    <select
                      id="unit-assign-owner"
                      value={assignForm.owner_id}
                      onChange={(e) =>
                        setAssignForm((f) => ({ ...f, owner_id: e.target.value }))
                      }
                      disabled={assignSaving}
                      className="w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] bg-slate-100 dark:bg-[#111520]"
                    >
                      <option value="">—</option>
                      {assignLists.owners.map((o) => (
                        <option key={o.id} value={o.id}>
                          {String(o.name || "").trim() ||
                            String(o.email || "").trim() ||
                            o.id}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {assignErr ? <p className="mt-3 text-sm text-[#f87171]">{assignErr}</p> : null}
              <div className="flex gap-2 justify-end mt-6">
                <button
                  type="button"
                  disabled={assignSaving}
                  onClick={onClose}
                  className="rounded-[8px] border border-black/10 bg-transparent px-4 py-2 text-sm font-semibold text-[#64748b] hover:bg-black/[0.03] dark:border-white/[0.1] dark:text-[#8090b0] dark:hover:bg-white/[0.04] disabled:opacity-50"
                >
                  Abbrechen
                </button>
                <button
                  type="button"
                  disabled={assignSaving || assignListsLoading}
                  onClick={onSave}
                  className="rounded-[8px] bg-gradient-to-r from-[#5b8cff] to-[#7c5cfc] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 border-none"
                >
                  {assignSaving ? "Speichern …" : "Speichern"}
                </button>
              </div>
            </div>
          </div>
  );
}
